import React, { useEffect } from 'react';
import { Container } from '@chakra-ui/react';
import { OverviewTable } from 'routes/travelRequestsOverview/OverviewTable/OverviewTable';
import { useNavigate } from 'react-router-dom';

export const HomePage = (): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/ferdabeidnir', { replace: true });
  }, [navigate]);

  return (
    <Container maxW="container.xl" marginStart="ltr">
      <OverviewTable />
    </Container>
  );
};
